<template>
  <div>
    <button style="font-weight: bold;" @click="openModal()" class="btn-outline button-secondary"><i class="fa-classic fa-arrow-up-from-line"></i>Bulk Import</button>
    <alert-modal v-if="isAlertOpen">
      <span><i class="fa-solid fa-circle-check"></i>Bulk allocation complete: {{ countCreated }} new, {{ countExisting }} existing</span>
    </alert-modal>
    <!-- modal bulk import -->
    <div class="modal-container" v-if="isModalOpen">
      <div class="modal-content">
        <h1>Bulk VIBAN Allocation<i @click="closeModal()" class="fa-regular fa-xmark"></i></h1>
        <span style="font-weight: normal; color: #717182;">Upload a CSV file with client numbers to allocate VIBANs in bulk.</span>
        <div class="information-container">
          <i class="fa-regular fa-file-lines"></i>
          <div>
            <span>CSV Template</span>
            <span>Download template with sample client numbers</span>
          </div>
          <button class="download-btn btn btn-outline" @click="exportCSVTemplate"><i class="fa-regular fa-arrow-down-to-bracket"></i>Download Template</button>
        </div>
        <!-- <div v-if="clients.length == 0" class="drop-zone"> -->
        <div
          v-if="clients.length == 0"
          class="drop-zone"
          :class="{ hover: isDragOver }"
          @dragover.prevent
          @dragenter.prevent="isDragOver = true"
          @dragleave.prevent="isDragOver = false"
          @drop.prevent="onDrop"
        >
          <i class="fa-regular fa-arrow-up-from-bracket"></i>
          <span>Drag and drop your CSV file here, or click to browse</span>
          <span>CSV file with clientNumber column</span>
          <div>
            <button @click="importCSVFile" type="file" class="btn-outline btn-dark"><i class="fa-regular fa-arrow-up-from-bracket"></i> Select CSV file</button>
          </div>
        </div>
        <div v-else>
          <div style="display: flex; justify-content: space-between; align-items: center; font-size: 1.25rem; font-weight: bold; color: black;">
            <span>Preview ({{ clients.length }} allocations)</span>
            <div style="display: flex; gap: 1rem;">
              <span :class="{'btn-outline button-primary' : clients.filter(item => item.status == 0).length > 0, 'btn-outline-light btn':  clients.filter(item => item.status == 0).length == 0}" :style="{cursor: 'default', 'pointer-events': 'none', 'background-color': clients.filter(item => item.status == 0).length > 0 ? '#f0fdf4':'white', color: clients.filter(item => item.status == 0).length > 0 ? '#008236':''}">{{ clients.filter(item => item.status == 0).length }} valid</span>
              <button class="btn-outline-light btn" @click="clients = []"><i class="fa-regular fa-xmark"></i> Clear</button>
            </div>
          </div>
          <div class="tables">
            <div class="thead">
              <th>#</th>
              <th>Status</th>
              <th>Client Number</th>
              <th>Result</th>
            </div>
            <div class="tbody">
              <div class="tr" v-for="(item, index) in clients" :key="index">
                <td>{{ index + 1 }}</td>

                <td><i style="color: #00a63e;" v-if="item.status == 0" class="fa-regular fa-circle-check"></i><i style="color: #155dfc;" v-else class="fa-regular fa-circle-xmark"></i></td>

                <td style="color: black; font-weight: bold;">{{ item.clientNumber }}</td>

                <td v-if="item.status == 0" style="color: #00a63e;">Will allocate new VIBAN</td>
                <td v-else style="color: #155dfc;">Already allocated: {{ item.VIBAN }}</td>
              </div>
            </div>
          </div>
          <div class="information-container" v-if="clients.some(item => item.status == 1)">
            <i class="fa-regular fa-circle-exclamation"></i>
            <div>
              <span>Existing Allocations Detected:</span>
              <span>{{clients.filter(item => item.status == 1).length}} client(s) already have VIBANs allocated. These will be returned without allocating new VIBANs.</span>
            </div>
          </div>
          <hr>
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <button class="btn-outline-light btn" @click="closeModal">Cancel</button>
            <button v-if="clients.filter(item => item.status == 0).length > 0" class="btn-outline btn-dark" @click="allocate">Process {{ clients.filter(item => item.status == 0).length }} Allocations</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import alertModal from './alertModal.vue';
export default {
  components: { alertModal },
  name: 'ImportVIBANModal',
  emits: ['update:refresh'],
  data(){
    return {
      isModalOpen: false,
      isAlertOpen: false,
      countCreated: 0,
      countExisting: 0,
      clients : [],
      isDragOver: false
    }
  },
  mounted() {
    window.addEventListener('dragover', e => e.preventDefault())
    window.addEventListener('drop', e => e.preventDefault())
  },
  methods: {
    openModal (){
      this.isModalOpen = true
    },
    closeModal (){
      this.isModalOpen = false
      this.clients = []
    },
    exportCSVTemplate (){
      let firstLine = 'clientNumber' + '\r\n'

      let line = ''
      line += 'CLI-12345678'  + '\r\n'
      line += 'CLI-87654321' + '\r\n'
      line += 'CLI-11223344' + '\r\n'

      let data = firstLine + line
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      let today = moment()
      let fileName = 'import_CSV_template_' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    allocate(){
      let requests = this.clients
      .filter(item => item.status == 0)
      .map(item => {
        this.countCreated += 1
        return this.$engine.services.payments.createGroup(item.clientNumber);
      });

      this.countExisting = this.clients.length - this.countCreated
      
      Promise.all(requests)
      .then(responses => {
        this.closeModal()
        this.isAlertOpen = true;
        setTimeout(()=>{
          this.isAlertOpen = false;
          this.countExisting = 0
          this.countCreated = 0
        }, 3000)
        this.$emit('update:refresh')
      })
      .catch(err => console.log(err));
    },
    onDrop(event) {
      this.isDragOver = false
      const file = event.dataTransfer.files[0]
      this.readCSVFile(file)
    },
    readCSVFile(file) {
      if (!file || !file.name.endsWith('.csv')) return

      const reader = new FileReader()
      reader.onload = (e) => {
        const csvText = e.target.result
        const fileContent = csvText
          .trim()
          .split('\r\n')
          .filter(item => item && item !== 'clientNumber')

        fileContent.forEach(el => {
          this.checkAllocation(el)
        })
      }
      reader.readAsText(file)
    },
    checkAllocation(data){
      const sanitized = this.sanitize(data)
      if (!sanitized) return

      this.$engine.services.payments.getGroups({ search : sanitized , maxResults : 200})
      .then(res => {
        if(res.data.references.length == 0) this.clients.push({
          clientNumber: data,
          status: 0
        })
        else{
          if(!res.data.references.some(item => item.Reference1 == data)){
            this.clients.push({
              clientNumber: data,
              status: 0
            })
          }else{
            this.clients.push({
              clientNumber: data,
              status: 1,
              VIBAN: res.data.references.filter(item => item.Reference1 == data)[0].VIBAN
            })
          }
        }
      })
      .catch(err => console.log(err))
    },
    importCSVFile() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.csv'

      input.addEventListener('change', (event) => {
        const file = event.target.files[0]
        this.readCSVFile(file)
      })

      input.click()
    },
    sanitize(value) {
      if (typeof value !== 'string') return ''

      return value
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9-_]/g, '')
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .replace(/\r?\n|\r/g, '')
    }
  }
}
</script>
<style scoped>

.drop-zone.hover {
  border-color: #155dfc;
  background-color: #eff6ff;
}

.tables{
  border: 1px solid #ebe6e7;
  border-radius: 0.625rem;
  max-height: 15rem;
  overflow: scroll;
  margin: 1rem 0rem;
}

.tables .thead{
  background-color: #f8f9fa !important;
  color: #000;
  border-bottom: 1px solid #ebe6e7;
}

.tables .tbody{
  background-color: #fff !important;
}

.tables .tbody .tr{
  border-bottom: 1px solid #ebe6e7;
}

.tables .thead th:nth-child(2), .tables .tbody .tr td:nth-child(2){
  width: 6rem;
}

.tables .thead th:nth-child(3), .tables .tbody .tr td:nth-child(3){
  width: 13rem;
}

th, td{
  text-align: left;
  padding: 1rem;
}

.download-btn{
  text-wrap: nowrap;
  background-color: #fff !important;
  border-color: #8ec5ff !important;
  display: flex !important;
  gap: 1rem;
}

.drop-zone{
  row-gap: 1rem;
  border: 2px dashed #d1d5dc;
  background-color: #f8f8f8;
  border-radius: 0.625rem;
  padding: calc(.25rem * 12);
  display: grid !important;
  justify-content: center !important;
  align-items: center !important;
}

.drop-zone>i{
  display: flex;
  justify-content: center;
  font-size: calc(.25rem * 12);
  font-weight: bold;
  color: #99a1af;
  margin: 1rem 0rem;
}

.drop-zone>span{
  display: flex;
  justify-content: center;
}

.drop-zone:hover{
  border-color: #99a1af;
}

.drop-zone>div{
  display: flex;
  justify-content: center;
}

.information-container{
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: calc(.25rem * 4);
  background-color: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: .625rem;
  margin: 1rem 0rem;
}

.information-container>i {
  color: #155dfc;
  font-size: calc(.25rem * 5);
}

.information-container>div{
  display: grid;
}

.information-container>div>span:first-child{
  color: #1c398e;
  font-weight: bold;
}

.information-container>div>span:last-child{
  color: #1d4ed8;
}

.modal-container{
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5000;
  overflow: hidden;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content .filter-item {
  margin: 1rem 0rem;
}

.modal-content>h1{
  font-weight: bold;
  font-size: 1.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
}

.modal-content>h1>i{
  cursor: pointer;
}

.modal-content>input{
  margin-bottom: 1.5rem;
}

.modal-content>span:first-of-type{
  color: #717182;
  margin-bottom: 1rem;
}

.modal-content>span:last-of-type{
  color: #000;
  font-weight: bold;
}
</style>